import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/pro-solid-svg-icons/faStar";
import { faStar as faStarRegular } from "@fortawesome/pro-regular-svg-icons/faStar";
import { useTranslation } from "react-i18next";

const SIZE_CLASSES = {
  sm: { icon: "h-5 w-5", pad: "p-0.5" },
  md: { icon: "h-6 w-6", pad: "p-1" },
  lg: { icon: "h-8 w-8", pad: "p-1" },
} as const;

export function StarRow({
  rating,
  onRate,
  size = "md",
  variant = "filled",
}: {
  rating: number | null;
  onRate: (n: number) => void;
  size?: "sm" | "md" | "lg";
  variant?: "filled" | "outline";
}) {
  const { t } = useTranslation("pois");
  const { icon: iconClass, pad: padClass } = SIZE_CLASSES[size];

  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((n) => {
        const isSelected = rating !== null && n <= rating;
        const icon = isSelected
          ? faStar
          : variant === "outline"
            ? faStarRegular
            : faStar;
        const colorClass = isSelected
          ? "text-amber-400"
          : variant === "outline"
            ? "text-foreground/[0.16] hover:text-amber-400"
            : "text-muted-foreground hover:text-amber-400";

        return (
          <button
            key={n}
            onClick={() => onRate(n)}
            className={padClass}
            aria-label={t("rating.rateStars", { count: n })}
          >
            <FontAwesomeIcon
              icon={icon}
              className={`${iconClass} transition-colors ${colorClass}`}
            />
          </button>
        );
      })}
    </div>
  );
}
